import { Component, ViewChild } from '@angular/core';

import { CalendarComponent } from 'src/app/common/calendar.component';

import { TouristGuidesFiltersComponent } from './tourist-guides-calendar-filters/tourist-guides-calendar-filters.component';

@Component({
	selector: 'app-tourist-guides-calendar',
	templateUrl: './tourist-guides-calendar.component.html',
	styleUrls: ['./tourist-guides-calendar.component.css'],
})
export class TouristGuidesCalendarComponent extends CalendarComponent {
	@ViewChild(TouristGuidesFiltersComponent) touristGuidesFiltersComponent: TouristGuidesFiltersComponent;
	private itemsBeforeDataLoad = 4;
	data: Array<any>;
	allDrivers: Array<any> = [];
	allTouristGuides: Array<any> = [];
	vehicles: Array<any> = [];
	touristGuides: Array<any> = [];
	touristGuideTypes: Array<any> = [];
	eventTypes: Array<any> = [];
	cities: Array<any> = [];
	users: Array<any> = [];
	parameters = {
		status: [],
		category: [],
		touristGuideTypes: [],
		touristGuide: [],
		rates: null,
	};
	filters = {
		touristGuide: [],
		touristGuideType: [],
		rates: null,
	};
	selectedObject = {
		id: null,
		name: null,
	};

	protected loadAdditionalData(): void {
		this.api.get('/vehicles/', (result, error) => {
			this.vehicles = result.data;
		});
		this.api.get('/touristGuides/', (result, error) => {
			result.data.forEach((obj) => {
				obj.name = obj.lastName + ' ' + obj.firstName;
				obj.rate = '';
			});
			this.allTouristGuides = result.data;
		});
		this.api.get('/parameters/', (result, error) => {
			this.parameters.category = result.data.filter((obj) => obj.type_parameters_id == 6);
			this.parameters.status = result.data.filter((obj) => obj.type_parameters_id == 7);
		});
		this.api.get('/drivers/', (result, error) => {
			this.allDrivers = result.data;
		});
		this.api.get('/touristGuidesEventsTypes/', (result, error) => {
			this.eventTypes = result.data;
			this.loadData();
		});
		this.api.get('/touristGuideTypes/', (result, error) => {
			this.parameters.touristGuideTypes = result.data;
			this.loadData();
		});
		this.api.get('/users/', (result, error) => {
			this.users = result.data;
		});
	}

	protected loadData(): void {
		this.itemsBeforeDataLoad--;
		if (this.itemsBeforeDataLoad > 0) {
			return;
		}
		delete this.filters['date_from'];
		delete this.filters['date_to'];
		this.loader.show();
		this.api.get('/touristGuides/?' + this.touristGuidesFilters(), (result, error) => {
			this.touristGuides = this.parseTouristGuides(result.data);
			let parms: string = this.api.getChecked(this.filters);
			parms += '&date_from=' + this.date_from;
			parms += '&date_to=' + this.date_to;
			this.api.get('/tourismEvents/?' + parms, (result, error) => {
				this.parseDataToGridFormat(result.data);
				this.api.get('/touristGuidesEvents/?status=1&' + parms, (result, error) => {
					this.data = this.parseEventsToGridFormat(result.data);
					this.loader.hide();
				});
			});
		});
	}

	private touristGuidesFilters(): string {
		const parms: Array<string> = [];
		if (this.filters.touristGuide?.length) {
			parms.push('touristGuide=' + this.filters.touristGuide);
		}
		if (this.filters.touristGuideType?.length) {
			parms.push('touristGuideType=' + this.filters.touristGuideType);
		}
		if (this.filters.rates?.length) {
			parms.push('rates=' + this.filters.rates);
		}
		return parms.join('&');
	}

	private parseTouristGuides(data) {
		const result: Array<any> = [];
		data.forEach((touristGuide) => {
			touristGuide.comments = touristGuide.comments ? touristGuide.comments : '';
			const type = this.parameters.touristGuideTypes.find((tgTypeObj) => tgTypeObj.id == touristGuide.type);
			const typeOrder = type ? type.order : '999';
			result.push({
				id: touristGuide.id,
				name: touristGuide.lastName + ' ' + touristGuide.firstName,
				typeOrder: typeOrder,
				events: [],
				checked: true,
				background: type?.background,
				details: [
					{
						label: '',
						value: '<a href="/touristGuides/' + touristGuide.id + '" target="_blank">Strona pilota</a>',
					},
					{
						label: 'Telefon',
						value: [touristGuide.phoneBusiness, touristGuide.phonePrivate],
					},
					{
						label: 'E-mail',
						value: [touristGuide.emailBusiness, touristGuide.emailPrivate],
					},
					{
						label: 'Ocena',
						value: [touristGuide.rate],
					},
					{
						label: 'Uwagi',
						value: [touristGuide.comments],
					},
				],
			});
		});
		// sort by type and name
		const sorted = result
			.sort((a, b) => a.name.localeCompare(b.name))
			.sort((a, b) => a.typeOrder.localeCompare(b.typeOrder));
		return sorted;
	}

	private parseEventsToGridFormat(data) {
		data.forEach((event) => {
			const type = this.eventTypes.find((obj) => obj.id == event.type);
			event.color = type ? '#' + type.color : '#999999';
			event.name = type ? type.name : '???';
			event.kind = 'touristGuide';
			event.touristGuides.forEach((touristGuideId) => {
				const touristGuide = this.touristGuides.find((obj) => obj.id == touristGuideId);
				if (!touristGuide) {
					return;
				}
				let eventName = event.name;
				if (event.comments) {
					eventName += ' - ' + event.comments;
				}
				touristGuide.events.push({
					id: event.id,
					name: eventName,
					date_from: event.date_from,
					date_to: event.date_to,
					background: event.color,
					kind: event.kind,
				});
			});
		});
		return this.touristGuides;
	}

	private parseDataToGridFormat(data) {
		data.forEach((event) => {
			event.kind = 'transport';
			event.color = '#6A5ACD';
			this.parseCrewsToGridFormat('departure', event);
			this.parseCrewsToGridFormat('program', event);
			this.parseCrewsToGridFormat('return', event);
		});
		return this.touristGuides;
	}

	private parseCrewsToGridFormat(type, event) {
		event['tourist_guides_' + type].forEach((touristGuideId) => {
			const touristGuide = this.touristGuides.find((obj) => obj.id == touristGuideId);
			if (!touristGuide) {
				return;
			}
			let date_from = event.date_from;
			let date_to = event.date_to;
			let eventName = '';
			switch (type) {
				case 'departure':
					eventName = '(D) ' + event.name;
					if (event.program_date_from) {
						date_to = event.program_date_from;
					}
					break;
				case 'program':
					eventName = '(P) ' + event.name;
					break;
				case 'return':
					eventName = '(O) ' + event.name;
					if (event.program_date_to) {
						date_from = event.program_date_to;
					}
					break;
			}
			touristGuide.events.push({
				id: event.id,
				name: eventName,
				date_from: date_from,
				date_to: date_to,
				background: event.color,
				kind: event.kind,
			});
		});
	}

	eventOpen(event) {
		switch (event.element.kind) {
			case 'transport':
				this.selectedObject = {
					id: event.id,
					name: event.name,
				};
				break;
			case 'touristGuide':
				window.open('/tourist-guides-event/' + event.id, '_blank').focus();
				break;
		}
	}

	eventClosed(event) {
		console.log(event);
	}

	filtersOpen() {
		this.touristGuidesFiltersComponent.filtersOpen();
	}
}
